import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import Heading from '../../heading/Heading';

class MarkdownHeading extends PureComponent {
    static propTypes = {
        children: PropTypes.node.isRequired,
        level: PropTypes.oneOf([1, 2, 3, 4, 5, 6])
    };

    render() {
        const {children, level} = this.props;

        return <Heading level={level}>{children}</Heading>;
    }
}

export default MarkdownHeading;
